import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { UserService } from '../services/user.service';
import { User } from '../../shared/models/user.interface';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { UserEditComponent } from '../edit/edit.component';
import { GenericDialogData } from '../../admin/models/generic.dialog.interface';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  dataSource = new MatTableDataSource<User>();
  displayedColumns: string[] =
    ['userName', 'phone', 'email', 'action'];

  users: User[];
  errors: string;

  constructor(private userService: UserService, public dialog: MatDialog, private snackBar: MatSnackBar) {
    
  }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.searchUsers();
  }

  searchUsers() {
    this.userService.getList(null)
      .subscribe({
        next: (data) => {
          this.users = data;

          this.dataSource.data = this.users;
        }
      });
  }

  showEdit(userId) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = { id: userId } as GenericDialogData;
    dialogConfig.width = '1100px';
    dialogConfig.maxHeight = '950px';

    const dealerDialogRef = this.dialog.open(UserEditComponent, dialogConfig);

    dealerDialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      this.searchUsers();
    });
  }

  toggleStatus(userId) {
    this.errors = '';
    this.userService.toggleStatus(userId)
      .pipe()
      .subscribe(
        {
          next: (result) => {
            console.log(result);
            if (result.id != null) {
              this.users.find(u => u.id == userId).isActive = result.isActive;
              let activeStatusId = "user_status_active" + userId;
              let inActiveStatusId = "user_status_inactive" + userId;

              if (result.isActive) {
                document.getElementById(activeStatusId).className = "text-success";
                document.getElementById(inActiveStatusId).className = "";
              }
              else {
                document.getElementById(activeStatusId).className = "";
                document.getElementById(inActiveStatusId).className = "text-danger";
              }
            }
          },
          error: (error: string) => {
            this.errors = error
            console.log(this.errors);
            // on an error we need to put the switch back to the original position
            let statusId = "user_status_" + userId
            let userStatus = (<HTMLInputElement>document.getElementById(statusId)).checked;
            (<HTMLInputElement>document.getElementById(statusId)).checked = !userStatus;
            this.snackBar.open(this.errors, null, { duration: 3000, verticalPosition: 'bottom', panelClass: ['bidit-snackbar-alert'] })
          }
        });
  }
}
